"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportDashboardToPdfHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var dashboard_1 = require("../../events/dashboard");
var metaSelectors_1 = require("../../store/meta/metaSelectors");
var general_1 = require("../../events/general");
var filterContextSelectors_1 = require("../../store/filterContext/filterContextSelectors");
var filterUtils_1 = require("../../../_staging/exportUtils/filterUtils");
function exportDashboardToPdf(ctx, dashboardRef, filters) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend.workspace(workspace).dashboards().exportDashboardToPdf(dashboardRef, filters);
}
function exportDashboardToPdfHandler(ctx, cmd) {
    var dashboardRef, filterContextFilters, effectiveFilters, resultUri, fullUri;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(dashboard_1.dashboardExportToPdfRequested(ctx, cmd.correlationId))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(metaSelectors_1.selectDashboardRef)];
            case 2:
                dashboardRef = _a.sent();
                if (!dashboardRef) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Dashboard to export to PDF must have an ObjRef.");
                }
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextFilters)];
            case 3:
                filterContextFilters = _a.sent();
                effectiveFilters = filterUtils_1.ensureAllTimeFilterForExport(filterContextFilters);
                return [4 /*yield*/, effects_1.call(exportDashboardToPdf, ctx, dashboardRef, effectiveFilters)];
            case 4:
                resultUri = _a.sent();
                fullUri = ctx.backend.config.hostname
                    ? new URL(resultUri, ctx.backend.config.hostname).href
                    : resultUri;
                return [2 /*return*/, dashboard_1.dashboardExportToPdfResolved(ctx, fullUri, cmd.correlationId)];
        }
    });
}
exports.exportDashboardToPdfHandler = exportDashboardToPdfHandler;
//# sourceMappingURL=exportDashboardToPdfHandler.js.map